module.exports = __webpack_public_path__ + "static/media/part-1.d4cb3b27.jpg";